/* eslint-disable max-statements */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
import { all, call, takeLatest, put, select, fork, delay } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import logger from '@tcp/core/src/utils/loggerInstance';
import { isSafariBrowser } from '@tcp/core/src/utils';
import {
  getRegisteredUserInfoCachingInterval,
  getIsRtpsBrowsePrescreenEnabled,
  getIsGuestRegisteredCallEnabled,
  getIsGuestFavEnabled,
  getIsGuestFavAppEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { submitUserSurvey } from '@tcp/core/src/services/abstractors/account/UpdateProfileInfo';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { updateProfileSuccess } from '@tcp/core/src/components/features/account/MyProfile/container/MyProfile.actions';
import { getFavoriteStoreActn } from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import { setDefaultWishListIdActn } from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions';
import { resetCartCache } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import { updateRTPSData } from '@tcp/core/src/services/abstractors/CnC/Checkout';
import { setIsRTPSFlow } from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action.util.js';
import { removeCookie } from '@tcp/core/src/utils/cookie.util';
import {
  setPlccEligible,
  setPlccPrescreenCode,
  setPrescreenFromBrowse,
} from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.actions';
import countryListAbstractor from '../../../../../services/abstractors/bootstrap/countryList';
import {
  setCountry,
  setCurrency,
  setLanguage,
  setCountryName,
} from '../../../../../reduxStore/actions';
import CONSTANTS from '../User.constants';
import {
  setUserInfo,
  setIsRegisteredUserCallDone,
  setIsFetching,
  setLoginInProcessState,
} from './User.actions';
import { getProfile } from '../../../../../services/abstractors/account/Login';
import { validateReduxCache } from '../../../../../utils/cache.util';
import {
  getSiteId,
  routerPush,
  getAPIConfig,
  readCookie,
  removeURLParameter,
} from '../../../../../utils';
import { setLocalStorage } from '../../../../../utils/localStorageManagement';
import { API_CONFIG } from '../../../../../services/config';
import { defaultCountries, defaultCurrencies } from '../../../../../constants/site.constants';
import { getNavigateXHR } from '../../../../../services/abstractors/account/NavigateXHR';
import { setNavigateCookieToken } from '../../NavigateXHR/container/NavigateXHR.action';
import { guestFavCheck } from '../../../browse/ProductListing/molecules/ProductList/utils/utility';

export const getDataSetActions = (payload, response, userCachingTTL) => {
  const dataSetActions = [];
  const { country, currency } = response;

  response.userCachingTTL = userCachingTTL;

  if (country) {
    dataSetActions.push(put(setCountry(country)));
  }
  dataSetActions.push(
    put(setCurrency({ currency })),
    put(setUserInfo(response)),
    put(setIsRegisteredUserCallDone(true))
  );

  return dataSetActions;
};

export const getPrescreenPayload = (
  addresses,
  profileAddress,
  shippingAddressId,
  firstName,
  lastName
) => {
  const mailingAddress = profileAddress?.isComplete
    ? profileAddress?.address
    : addresses?.find((address) => address.addressId === shippingAddressId);

  const { address1, address2, city, state, stateCode, country, countryCode, zipCode, postalCode } =
    mailingAddress || {};
  return isEmpty(mailingAddress)
    ? null
    : {
        firstName,
        lastName,
        addressLine1: address1,
        addressLine2: address2,
        city,
        state: state || stateCode,
        country: country || countryCode,
        zipCode: zipCode || postalCode,
      };
};

export function* setCountryCurrency(response) {
  const { country, currency } = response;
  const [us, ca] = defaultCountries;
  const [currencyAttributesUS, currencyAttributesCA] = defaultCurrencies;
  let currencyAttributes = {};
  let countryAttributes = {};
  if (country === us.id) {
    currencyAttributes = currencyAttributesUS;
    countryAttributes = us;
  } else if (country === ca.id) {
    currencyAttributes = currencyAttributesCA;
    countryAttributes = ca;
  } else {
    const res = yield call(countryListAbstractor.getData, country);
    const countryList = res && res.data.countryList;
    const currentCountry =
      countryList.length && countryList?.find((item) => item?.country?.id === country);
    const { country: countryObj, currency: currencyObj, exchangeRate } = currentCountry;
    currencyAttributes = { ...currencyObj, ...exchangeRate };
    countryAttributes = countryObj;
  }
  yield put(
    setCurrency({
      currency,
      currencyAttributes,
    })
  );
  yield put(setCountryName((countryAttributes && countryAttributes.displayName) || ''));
}

export const checkForNonGenericUser = () => {
  return Promise.resolve(readCookie('cid'));
};

export const checkForUsidExists = () => {
  return new Promise((resolve) => {
    const usid = readCookie('usid');
    const usidCa = readCookie('usid_CA');
    resolve(usid || usidCa);
  });
};

const moveToHomePage = (response) => {
  const siteId = getSiteId();
  const { CA_CONFIG_OPTIONS: apiConfig, siteIds } = API_CONFIG;
  const { country } = response;
  if (country === siteIds.ca.toUpperCase() && siteId !== apiConfig.siteId) {
    routerPush(window.location, '/home', null, siteId);
  }
};

function* getCrossDomainCookie({ ct, router }) {
  if (ct) {
    const { asPath, pathname, query } = router || {};
    const { brandId } = getAPIConfig();
    yield call(getNavigateXHR, { ct });
    setLocalStorage({ key: `${brandId && brandId.toLowerCase()}_ct`, value: ct });
    yield put(resetCartCache());
    yield put(
      setNavigateCookieToken({
        encodedcookie: ct,
      })
    );

    const updatedAspath = removeURLParameter(asPath, 'ct');
    router.push({ pathname, query }, `${updatedAspath}`);
  }
}

function* getRtpsPrescreenCode(response) {
  try {
    const {
      isPlcc,
      isLoggedin,
      addresses,
      firstName,
      lastName,
      email: emailAddress,
      phone: businessPhoneNumber,
      shippingAddressId,
      profileAddress,
    } = response || {};
    if (
      !isPlcc &&
      isLoggedin &&
      (profileAddress?.isComplete || (shippingAddressId && addresses?.length))
    ) {
      const address = getPrescreenPayload(
        addresses,
        profileAddress,
        shippingAddressId,
        firstName,
        lastName
      );

      if (address) {
        const res = yield call(
          updateRTPSData,
          true,
          false,
          address,
          businessPhoneNumber,
          emailAddress
        );

        yield all([
          put(setPlccEligible(res.plccEligible)),
          put(setPlccPrescreenCode(res.prescreenCode)),
          put(setPrescreenFromBrowse(true)),
        ]);

        if (res.plccEligible) {
          yield put(setIsRTPSFlow(true));
        }
      }
    }
  } catch (e) {
    logger.error(e);
  }
}

// eslint-disable-next-line complexity
export function* getUserInfoSaga({ payload = {} } = {}) {
  const { isPendingWishlistedProduct, isCalledFromLoginSaga } = payload;
  try {
    const { loadFavStore = false, ct = '', router, apiSuccess = false, source } = payload;
    const state = yield select();
    const isGuestFavWebEnabled = getIsGuestFavEnabled(state);
    const isGuestFavAppEnabled = getIsGuestFavAppEnabled(state);
    const isGuestFavEnabled = guestFavCheck(isGuestFavWebEnabled, isGuestFavAppEnabled);
    yield put(setLoginInProcessState(true));
    yield put(setIsFetching(true));
    yield put(setIsRegisteredUserCallDone(false));
    const userCachingTTL = yield select(getRegisteredUserInfoCachingInterval);
    let cookieToken = ct;
    if (isSafariBrowser() && !ct && source === 'firstload') {
      cookieToken = readCookie('ct') || '';
      removeCookie('ct');
    }
    yield call(getCrossDomainCookie, { ct: cookieToken, router });
    if (cookieToken) yield delay(100);
    const isNonGenericUser = yield call(checkForNonGenericUser);
    const isUsidExists = yield call(checkForUsidExists);
    const isGuestRegisteredCallEnabled = yield select(getIsGuestRegisteredCallEnabled);
    const callGRUforGuest = !!isUsidExists && isGuestRegisteredCallEnabled;
    if (isNonGenericUser || apiSuccess || callGRUforGuest) {
      const refresh = payload?.refresh || !!isUsidExists;
      const response = yield call(getProfile, { refresh });
      const { language } = response;

      if (
        response.defaultWishListId &&
        (isGuestFavEnabled ||
          (!(isPendingWishlistedProduct && isCalledFromLoginSaga) && !isGuestFavEnabled))
      ) {
        yield put(setDefaultWishListIdActn(response.defaultWishListId));
      }

      const dataSetActions = getDataSetActions(payload, response, userCachingTTL);
      yield all(dataSetActions);
      /**
       * Below code is to get currency attributes based on
       * current country returned from getRegisteredUserInfo API
       */
      yield call(setCountryCurrency, response);
      const isRtpsBrowseEnabled = yield select(getIsRtpsBrowsePrescreenEnabled);
      if (isRtpsBrowseEnabled) yield fork(getRtpsPrescreenCode, response);

      if (language) {
        yield put(setLanguage(language));
      }

      moveToHomePage(response);

      if (loadFavStore && isNonGenericUser) {
        yield put(
          getFavoriteStoreActn({
            ignoreCache: true,
          })
        );
      }
    } else {
      const anonymousUser = {
        userId: -1002,
        isGuest: true,
        isRemembered: false,
        isExpressEligible: false,
        userProfileState: {},
      };
      const [country, , currency] = (readCookie('iShippingCookie') || 'US||USD').split('|');
      yield put(setCountry(country));
      yield put(setCurrency({ currency }));
      yield put(setUserInfo(anonymousUser));
      yield call(setCountryCurrency, { country, currency });
      yield put(setIsRegisteredUserCallDone(true));
    }

    if (callGRUforGuest && !isNonGenericUser) {
      const [country, , currency] = (readCookie('iShippingCookie') || 'US||USD').split('|');
      yield put(setCountry(country));
      yield put(setCurrency({ currency }));
      yield call(setCountryCurrency, { country, currency });
      yield put(setIsRegisteredUserCallDone(true));
    }
    yield put(setLoginInProcessState(false));
  } catch (err) {
    yield put(setIsRegisteredUserCallDone(true));
    yield put(setIsFetching(false));
    yield put(setLoginInProcessState(false));
    logger.error('Error in fetching user profile information', {
      error: err,
    });
  }
}

export function* setSurveyAnswersSaga(data) {
  yield put(setLoaderState(true));
  try {
    yield call(submitUserSurvey, data);
    yield call(getUserInfoSaga);
    yield put(updateProfileSuccess('successMessage'));
    yield put(setLoaderState(false));
  } catch (err) {
    yield put(setLoaderState(false));
    yield null;
  }
}

export function* UserSaga() {
  const cachedUserInfo = validateReduxCache(getUserInfoSaga);
  yield takeLatest(CONSTANTS.GET_USER_INFO, cachedUserInfo);
  yield takeLatest(CONSTANTS.SET_SURVEY_ANSWERS, setSurveyAnswersSaga);
}

export default UserSaga;
